import { Column } from '~components/table-view';

const columns: Column[] = [
  {
    id: 'client_name',
    header: 'Client Name',
    type: 'text',
  },
  {
    id: 'ref',
    header: 'Reference',
    type: 'text',
  },
  {
    id: 'package',
    header: 'Package',
    type: 'text',
  },
  {
    id: 'funding_type',
    header: 'Funding Type',
    type: 'text',
  },
  {
    id: 'removed_count',
    header: 'Services Removed',
    type: 'text',
  },
  {
    id: 'price_missing_count',
    header: 'Price Missing',
    type: 'text',
  },
];

export default columns;
